import gql from 'graphql-tag';

import countsFragment from '../fragments/countsFragment';

export const queryCounts = gql`
  query counts {
    counts {
      ...countsFragment
    }
  }
  ${countsFragment}
`;
export default queryCounts;
